<script setup lang="ts">
import TypographyItem from '@/components/Typography/TypographyItem.vue'
import { ECommandStatusColors, ECommandStatusLabels } from '@/types/enum/CommandStatusEnum'
import type { DeviceCommandHistoryModel } from '@/types/models/DeviceCommandHistoryModel'
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'
import { isNullOrUndefined } from '../../../../../utils/validateUtils'

type Props = {
    command: DeviceCommandHistoryModel
}
defineProps<Props>()
</script>

<template>
    <TypographyItem :label="command.name" />
    <TypographyItem
        :label="$t(ECommandStatusLabels[command.status])"
        :class="`has-text-${ECommandStatusColors[command.status]}`" />
    <TypographyItem
        :label="`${$t('device.actions.commands.createdAt')}: ${moment(command.created_at).format(
            DATETIME_FORMAT
        )}`" />
    <TypographyItem v-if="!isNullOrUndefined(command.progress)" :label="`${command.progress}%`" />
</template>
